import React from 'react'

import KindleClippings  from 'react-kindle-clippings'
import 'react-kindle-clippings/dist/index.css'

const App = () => {
  return <KindleClippings 
    url="https://thisisrajiraj.github.io/posts/kindleclippings.txt" />
}

export default App
